<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="4" :lg="4">
          <el-input placeholder="手机号" v-model="mobile" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-table :data="signinData" :height="wheight-210" v-loading="loading">
        <el-table-column prop="id" label="记录ID" width="90"></el-table-column>
        <el-table-column prop="user_id" label="会员ID" width="100"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="140"></el-table-column>
        <el-table-column prop="activity_id" label="活动ID" width="90"></el-table-column>
        <el-table-column prop="act_name" label="活动名称" width="180"></el-table-column>
        <el-table-column prop="awards_id" label="奖励配置ID" width="110"></el-table-column>
        <el-table-column label="奖励类型" width="100">
          <template slot-scope="scope">
            <el-tag v-if="awardType(scope.row.awards_content) === 'points'">积分</el-tag>
            <el-tag v-else-if="awardType(scope.row.awards_content) === 'coupon'" type="warning">优惠券</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="awards_content" label="奖励内容" min-width="160"></el-table-column>
        <el-table-column prop="send_status" label="发放状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.send_status=='1'" type="success">已发放</el-tag>
            <el-tag v-else type="danger">待发放</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="err_msg" label="错误信息" min-width="160">
          <template slot-scope="scope">
            {{scope.row.err_msg}}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180">
          <template slot-scope="scope">
            {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="resend(scope.row)" :disabled="scope.row.send_status == '1'">补发</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pagesize" class="content-padded tc">
        <el-pagination background layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pagesize'>
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isMobile } from '../../../utils/validate'
import {
  storeSigninAwardList,
  resendStoreSigninAward
} from '../../../api/store_sign'

export default {
  data () {
    return {
      loading: false,
      total_count: 0,
      signinData: [],
      params: {
        page: 1,
        pagesize: 20
      },
      mobile: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    // 奖励日志表未存储奖励类型，只能从 awards_content 文案推断
    awardType (content) {
      var text = String(content || '')
      if (text.indexOf('优惠券') !== -1) {
        return 'coupon'
      }
      if (text.indexOf('积分') !== -1) {
        return 'points'
      }
      return ''
    },
    getSigninList () {
      this.loading = true
      storeSigninAwardList(this.params).then(response => {
        this.loading = false
        if (response.data.data && response.data.data.list) {
          this.signinData = response.data.data.list
          this.total_count = Number(response.data.data.total_count)
        } else {
          this.signinData = []
          this.total_count = 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      this.getSigninList()
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    keywordsSearch () {
      var mobile = String(this.mobile || '').trim()
      // 后端对 mobile 做精确匹配且会校验格式，不合法直接返回 422
      if (mobile && !isMobile(mobile)) {
        this.$message({ showClose: true, message: '请输入正确的11位手机号', type: 'warning' })
        return
      }
      this.params.page = 1
      this.params.mobile = mobile
      this.getSigninList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getSigninList()
    },
    resend (row) {
      this.$confirm('确定要重新发送到店签到奖励吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        resendStoreSigninAward({ id: row.id }).then(response => {
          this.loading = false
          var data = response.data.data || response.data
          if (data.success === true || data.status === true || data.code === 0) {
            this.$message({
              type: 'success',
              message: data.message || data.msg || '补发成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: data.message || data.msg || '补发失败'
            })
          }
          this.getSigninList()
        }).catch(() => {
          this.loading = false
          this.getSigninList()
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.getSigninList()
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// signinaward.vue?4eb7956c